import React, { Fragment, useState } from "react";
import ReactECharts from "echarts-for-react";
import { useNavigate } from "react-router-dom";
import styles from "Components/Dashboard/dashboard.module.scss";
import { Popover, Spin } from "antd";
import { useAppDispatch, useAppSelector } from "store/hook";
import { setFilter } from "Components/Topology/Device/deviceTableSlice";
import { getOption, ChartClick } from "Components/Dashboard/Components/utils";
import { useDeviceStatus } from "Components/Dashboard/queries";
import { Label, ChartContainer, DashCard } from "./Shared";

// 預設模型
const defaultModel = { model: { Model: 0 } };

// 顏色陣列
const color = [
  "#28a745",
  "#ffc107",
  "#343a40",
  "gray",
  "#0000FF",
  "#5599FF",
  "#C71585",
  "#FF88C2",
  "#7700BB",
  "#9F88FF",
  "#FF8800",
  "#00AAAA",
  "#66CDAA",
  "#668800",
  "#AA7700",
  "#DDAA00",
  "#FFDD55",
  "#666666",
  "#AAAAAA",
];

// Model_Pie 元件
const Model_Pie = React.memo(() => {
  // 從全局狀態中獲取所需數據
  const { level, stateCid, loginCid, isLogin } = useAppSelector((status) => status.global);
  // 獲取設備狀態數據
  const { data, isLoading: loading, isFetching } = useDeviceStatus(level, stateCid, loginCid, isLogin);
  // 控制彈出框顯示與隱藏的狀態 Model 各設備圖標隱藏效果 預設 false
  const [popVisible, setPopVisible] = useState(false);
  // 獲取模型列表和表格數據
  const modelList = data?.response?.models || [];
  const tableData = data?.response?.tableData || [];
  const disp = useAppDispatch();
  const navigate = useNavigate();
  // 將Model列表轉換為包含Model及對應數量的數組
  const model_number: [string, number][] = modelList.map((model) => [
    // 將取得的 model 字串轉換為大寫
    model.toUpperCase(),
    // 取得 對應的 model 的數量陣列
    tableData.filter((data) => data.model === model).length,
  ]);

  // 處理圖表點擊事件的函數
  const onChartClick = (params: ChartClick, label: string) => {
    const selected = params?.data?.name;
    // TODO: 已修改 label 點擊後跳轉 /Overview Model 無法顯示資料問題，因為要大寫才能讀取到資料
    disp(setFilter({ model: [selected ?? label.toUpperCase()] }));
    navigate("./overview");
  };
  // 圖表事件配置
  const onEvents = {
    click: onChartClick,
  };

  // 測試用
  // const model_name = model_number.map((item) => item[0]);
  // console.log("model_name", model_name);

  return (
    <div>
      <DashCard title={"Model"}>
        {loading || isFetching ? (
          <Fragment>
            {/* <Label devicestatic={Object.entries(defaultModel.model)} /> */}
            <Spin className={styles.loadingSpin} />
          </Fragment>
        ) : (
          <Fragment>
            <Popover
              // 彈出卡片的位置
              placement="left"
              // 彈出卡片的內容與樣式
              content={
                <div style={{ maxWidth: "500px", display: "flex" }}>
                  <Label
                    // TODO: 新增 彈出卡片圖標顏色，與 Model 的 圖標顏色一致
                    color={color.slice(0, model_number.length)}
                    // 顯示 model_number 資料型態為 [string, number]
                    devicestatic={model_number}
                    // 點擊跳轉事件
                    onChartClick={onChartClick}
                  />
                </div>
              }
              // 觸發方式：hover (滑鼠懸停在觸發元素上時顯示卡片)
              trigger="hover"
              // 設定卡片是否可見：在 popVisible 為 true 且 model_number 的長度大於 6 時可見
              visible={popVisible && model_number.length > 6}
              // 當 visible 為可見時，newVisible 是 true ；   當 visible 為不可見時，newVisible 是 false
              onVisibleChange={(newVisible: boolean) => setPopVisible(newVisible)}
            >
              <div>
                {/* 儀錶板 Model 上的圖標 顯示當前的 [ 數據設備型號 , 數量 ] */}
                <Label
                  // 工具測試用
                  // tooltip={model_name}
                  color={color.slice(0, model_number.length)}
                  // 判斷 "model_number長度" 若有資料 則顯示 model_number 陣列 [0] ~ [6] 筆資料 ； 若 沒資料則顯示空陣列
                  devicestatic={model_number.length ? model_number.slice(0, 6) : []}
                  // 點擊跳轉事件
                  onChartClick={onChartClick}
                />
              </div>
            </Popover>
            {/* Model 圓餅圖 */}
            {tableData.length !== 0 && (
              <ChartContainer sum={tableData.length}>
                <ReactECharts
                  className={styles.pie__chart}
                  option={getOption(model_number, color.slice(0, model_number.length))}
                  notMerge={true}
                  lazyUpdate={true}
                  theme={"theme_name"}
                  onEvents={onEvents}
                />
              </ChartContainer>
            )}
          </Fragment>
        )}
      </DashCard>
    </div>
  );
});

export default Model_Pie;
